module.exports = __webpack_public_path__ + "static/media/new_geller_white.afc828d5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new_geller_white.svg
// module id = ./src/assets/new_geller_white.svg
// module chunks = 0